import {FC} from "react";
import {TimePicker} from "antd";
import dayjs, {Dayjs, isDayjs} from "dayjs";

type Props = {
    value?: Dayjs | string;
    onChange?: (value: Dayjs) => void;
    placeholder?: string;
}

export const TimeInput: FC<Props> = ({ value, ...props }) => {
    const tValue = isDayjs(value) ? value : dayjs(value, 'HH:mm').utc(true);

    return (
        <TimePicker
            {...props}
            value={value ? tValue : undefined}
            format="HH:mm"
            minuteStep={15}
            needConfirm={false}
            style={{ width: '100px' }}
        />
    )
}